<template>
  <card>
    <time-toast
      class="animated fadeInUp time-toast"
      @close="$emit('checkOriginTime')"
      v-if="originTimeInvalid"
    ></time-toast>
    <div class="box__title">
      <div>배송유형</div>
    </div>
    <div class="box__content">
      <div>
        <div class="subtitle">픽업 유형을 선택해 주세요</div>
        <div class="type desktop">
          <div
            class="type__card"
            :class="{
              'type__card--active': getDeliveryOptions.isReserved === false,
            }"
            @click="
              updateIsReserved(false), resetPickupTime(), $emit('calculator')
            "
          >
            <img src="@/assets/img/order/incoming-envelope.png" />
            <div class="type__card--box">
              <div
                class="type__card--title"
                :class="{
                  title__active: getDeliveryOptions.isReserved === false,
                }"
              >
                즉시픽업
              </div>
              <div class="type__card--subTitle">바로 픽업해 주세요</div>
            </div>
          </div>
          <div
            class="type__card"
            :class="{ 'type__card--active': getDeliveryOptions.isReserved }"
            @click="updateIsReserved(true), (isPass = true)"
          >
            <img src="@/assets/img/order/calendar.png" />
            <div class="type__card--box">
              <div
                class="type__card--title"
                :class="{
                  title__active: getDeliveryOptions.isReserved === true,
                }"
              >
                예약픽업
              </div>
              <div class="type__card--subTitle">
                픽업 가능한 시간을 선택할게요
              </div>
            </div>
          </div>
        </div>
        <div class="type mobile">
          <div
            class="type__card"
            :class="{
              'type__card--active': getDeliveryOptions.isReserved === false,
            }"
            @click="
              updateIsReserved(false), resetPickupTime(), $emit('calculator')
            "
          >
            <div class="type__card--box">
              <img src="@/assets/img/order/incoming-envelope.png" />
              <div class="type__card--title">즉시픽업</div>
            </div>
            <div class="type__card--subTitle">바로 픽업해 주세요</div>
          </div>
          <div
            class="type__card"
            :class="{
              'type__card--active': getDeliveryOptions.isReserved === true,
            }"
            @click="updateIsReserved(true)"
          >
            <div class="type__card--box">
              <img src="@/assets/img/order/calendar.png" />
              <div class="type__card--title">예약픽업</div>
            </div>
            <div class="type__card--subTitle reserved">
              픽업 가능한 시간을<br />선택할게요
            </div>
          </div>
        </div>
        <div class="type__picker" v-if="getDeliveryOptions.isReserved">
          <picker
            :isPass="isPass"
            :originTimeInvalid="originTimeInvalid"
            @calculator="$emit('calculator')"
            @checkOriginTime="$emit('checkOriginTime')"
          />
        </div>
      </div>

      <div v-if="getDeliveryOptions.isReserved !== null">
        <div class="subtitle">배송 유형을 선택해 주세요</div>
        <div class="type desktop">
          <div
            class="type__card type__card--express"
            :class="{
              'type__card--active':
                getDeliveryOptions.isExpressDelivery === true,
            }"
            @click="updateIsExpressDelivery(true), $emit('calculator')"
          >
            <img src="@/assets/img/order/thunder.png" />
            <div class="type__card--box">
              <div
                class="type__card--title"
                :class="{
                  title__active: getDeliveryOptions.isExpressDelivery === true,
                }"
              >
                급송
              </div>
              <div class="type__card--subTitle" v-if="!loadingStatus">
                <span>{{
                  mixinsEstimatedTime(
                    getDeliveryOptions.isReserved
                      ? getDeliveryOptions.reserveExpressEstimatedMinutes
                      : getDeliveryOptions.expressEstimatedMinutes
                  )
                }}</span>
                <div class="type__card--fee">
                  {{
                    getDeliveryOptions.displayExpressTotalFee.toLocaleString()
                  }}원
                </div>
              </div>
              <div class="type__card--subTitle" v-else>
                <div class="loading">
                  <i class="fas fa-circle-notch fa-spin"></i>
                </div>
              </div>
            </div>
          </div>
          <div
            class="type__card type__card--express"
            :class="{
              'type__card--active':
                getDeliveryOptions.isExpressDelivery === false,
            }"
            @click="updateIsExpressDelivery(false), $emit('calculator')"
          >
            <img src="@/assets/img/order/big_box.png" />
            <div class="type__card--box">
              <div
                class="type__card--title"
                :class="{
                  title__active: getDeliveryOptions.isExpressDelivery === false,
                }"
              >
                일반
              </div>
              <div class="type__card--subTitle" v-if="!loadingStatus">
                <span>{{
                  mixinsEstimatedTime(
                    getDeliveryOptions.isReserved
                      ? getDeliveryOptions.reserveEstimatedMinutes
                      : getDeliveryOptions.estimatedMinutes
                  )
                }}</span>
                <div class="type__card--fee">
                  {{
                    getDeliveryOptions.displayNormalTotalFee.toLocaleString()
                  }}원
                </div>
              </div>
              <div class="type__card--subTitle" v-else>
                <div class="loading">
                  <i class="fas fa-circle-notch fa-spin"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="type mobile">
          <div
            class="type__card type__card--express"
            :class="{
              'type__card--active':
                getDeliveryOptions.isExpressDelivery === true,
            }"
            @click="updateIsExpressDelivery(true), $emit('calculator')"
          >
            <div class="type__card--box">
              <img src="@/assets/img/order/thunder.png" />
              <div class="type__card--title">급송</div>
            </div>
            <div class="type__card--subTitle" v-if="!loadingStatus">
              <span>{{
                mixinsEstimatedTime(
                  getDeliveryOptions.isReserved
                    ? getDeliveryOptions.reserveExpressEstimatedMinutes
                    : getDeliveryOptions.expressEstimatedMinutes
                )
              }}</span>
              <div class="type__card--fee">
                {{
                  getDeliveryOptions.displayExpressTotalFee.toLocaleString()
                }}원
              </div>
            </div>
            <div class="type__card--subTitle" v-else>
              <div class="loading">
                <i class="fas fa-circle-notch fa-spin"></i>
              </div>
            </div>
          </div>
          <div
            class="type__card type__card--express"
            :class="{
              'type__card--active':
                getDeliveryOptions.isExpressDelivery === false,
            }"
            @click="updateIsExpressDelivery(false), $emit('calculator')"
          >
            <div class="type__card--box">
              <img src="@/assets/img/order/big_box.png" />
              <div class="type__card--title">일반</div>
            </div>
            <div class="type__card--subTitle" v-if="!loadingStatus">
              <span>{{
                mixinsEstimatedTime(
                  getDeliveryOptions.isReserved
                    ? getDeliveryOptions.reserveEstimatedMinutes
                    : getDeliveryOptions.estimatedMinutes
                )
              }}</span>
              <div class="type__card--fee">
                {{
                  getDeliveryOptions.displayNormalTotalFee.toLocaleString()
                }}원
              </div>
            </div>
            <div class="type__card--subTitle" v-else>
              <div class="loading">
                <i class="fas fa-circle-notch fa-spin"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </card>
</template>
<script>
import card from "@/components/common/card.vue";
import picker from "./picker/layout.vue";
import dayjs from "dayjs";
import mixinOrder from "@/mixins/mixinOrder";
import mixinFilter from "@/mixins/mixinFilter";
import timeToast from "@/components/common/timeToast.vue";
export default {
  props: ["originTimeInvalid", "loadingStatus"],
  mixins: [mixinOrder, mixinFilter],
  components: {
    card,
    picker,
    timeToast,
  },
  data() {
    return {
      isPass: false,
    };
  },

  methods: {
    resetPickupTime() {
      this.updatePickupTime();
    },
  },
};
</script>
<style src="./layout.css" scoped></style>
<style src="@/assets/css/newGlobal.css" scoped></style>
